const OPEN_STATUSES = [0, 1, 2];

export const isOpenStatus = (status) => OPEN_STATUSES.includes(status);

export const formatLeadName = (lead) =>
  [lead?.firstName, lead?.lastName].filter(Boolean).join(' ') || 'Unnamed lead';

/**
 * Collapse a flat lead-task list into one entry per lead, preserving the order the
 * server returned so the existing due-date sort still drives the list.
 */
export const groupTasksByLead = (tasks = []) => {
  const byLead = new Map();

  tasks.forEach((task) => {
    const leadId = task?.leadResourceId;
    if (!leadId) return;

    if (!byLead.has(leadId)) {
      byLead.set(leadId, { leadResourceId: leadId, lead: task.lead, tasks: [] });
    }
    byLead.get(leadId).tasks.push(task);
  });

  return [...byLead.values()].map((group) => {
    const openTasks = group.tasks.filter((task) => isOpenStatus(task.status));
    return {
      ...group,
      name: formatLeadName(group.lead),
      openCount: openTasks.length,
      // The task the workflow is actually waiting on, if any.
      activeTask: openTasks.find((task) => task.workflowReady) || openTasks[0] || null,
    };
  });
};
